module.exports = __webpack_public_path__ + "img/clock.c9c5845f.svg";